import type { LoginRes } from '~/composables/useRequest/requests/data-contracts';


export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();

  let refreshTokenEvent: Promise<LoginRes> | undefined;

  const api: typeof $fetch = $fetch.create({
    retryStatusCodes: [401],
    retry: 1,
    baseURL: useRuntimeConfig().public.apiBaseUrl as string,

    async onRequest({ options }) {
      if (refreshTokenEvent) {
        try {
          await refreshTokenEvent;
        } catch {}
      }

      const currentLocale = getLocaleLanguage($i18n.locale.value);

      const token = localStorage.getItem('token');

      if (token) {
        options.headers.set('Authorization', `Bearer ${token}`);
        options.headers.set('X-Locale', currentLocale);
      }
    },

    async onResponseError({ options, response }): Promise<void> {
      const routeName = useRoute().name;

      if (response.status === 401 && !/^login___..$/.test(typeof routeName === 'string' ? routeName : '')) {
        const refreshToken = localStorage.getItem('refresh_token')?.toString() || '';

        if (refreshToken) {
          try {
            const { auth } = useRequest();

            if (!refreshTokenEvent) {
              localStorage.removeItem('token');
              refreshTokenEvent = auth.authControllerRefreshToken({ token: refreshToken });
            }

            const { payload: { accessToken, refreshToken: rt } } = await refreshTokenEvent;

            localStorage.setItem('token', accessToken);
            localStorage.setItem('refresh_token', rt);

            // Загружаем ресурсы страниц после обновления токена
            const { loadPageResources } = useRoles();

            await loadPageResources();

            options.headers.set('Authorization', `Bearer ${accessToken}`);

            return;
          } catch {
            //
          } finally {
            refreshTokenEvent = undefined;
          }
        }

        await useLogout();
      }
    },
  });

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api,
    },
  };
});
